import Image from "next/image"
import Zoom from "react-medium-image-zoom"
import { Attachment } from "airtable"
import ReactMarkdown from "react-markdown"
import { BodyText } from "../bodyText"
import Link from "next/link"
import { LongArrow } from "../home/card"

interface GrantsImageProps {
  image_url: string
  image_preview: Array<Attachment>
  caption: string
}
const GrantsImage = ({ image_preview, image_url, caption }: GrantsImageProps) => {
  const thisImage = image_preview[0].thumbnails && image_preview[0].thumbnails.large
  const width = thisImage && thisImage.width
  const height = thisImage && thisImage.height

  const altText = caption ? `${caption} – The Richard Pousette-Dart Foundation` : `The Richard Pousette-Dart Foundation`

  return (
    <div tw="py-2 flex flex-col font-sans space-y-4 order-first tablet:(w-mobile py-6 space-x-1 space-y-0 order-last)">
      <div tw="flex-grow-0">
        <Zoom
          zoomImg={{
            alt: altText,
            src: image_url,
            srcSet: image_url,
          }}
        >
          <Image src={image_url} width={width} height={height} alt={altText} />
        </Zoom>
      </div>
      <div tw="text-sm">
        <ReactMarkdown>{caption}</ReactMarkdown>
      </div>
    </div>
  )
}

interface CardProps {
  title: string
  body: string
  year: string
  image_url: string
  image_preview: Array<Attachment>
  caption: string
  external_link: string
}
const Card = (props: CardProps) => {
  const { body, image_preview, image_url, caption, year, title, external_link } = props
  const titleText = title ? title.toString() : ""
  const yearText = year ? `${year.toString()}: ${titleText}` : titleText
  const captionText = caption ? caption.toString() : ""
  const bodyText = body ? body.toString() : ""
  return (
    <>
      <div tw="col-span-4 tablet:(col-span-12)">
        <div tw="space-y-2 flex flex-col tablet:(space-x-12 flex-row)">
          <div tw="space-y-2 tablet:(w-tablet)">
            {yearText && <h3 tw="font-sans text-xl font-bold">{yearText}</h3>}
            <BodyText>
              <ReactMarkdown tw="">{bodyText}</ReactMarkdown>
            </BodyText>
            {external_link && (
              <p>
                <Link
                  tw="space-x-2 text-right text-xs font-sans flex justify-end h-full"
                  href={external_link.toString()}
                >
                  <span tw="uppercase">Learn more</span> <span tw="flex flex-col justify-center">{LongArrow}</span>
                </Link>
              </p>
            )}
          </div>
          {image_url && <GrantsImage image_url={image_url} image_preview={image_preview} caption={captionText} />}
        </div>
      </div>
    </>
  )
}

const GrantsIndex = (props: any) => {
  const { contentData } = props

  if (!contentData) {
    return <></>
  }

  return (
    <div tw="max-w-screen-desktop-lg desktop-lg:mx-auto px-4 relative">
      <div tw="grid grid-cols-4 desktop:(grid-cols-12) gap-4 gap-y-8 desktop:(gap-6 gap-y-8)">
        <>
          {contentData.map((cardData: any, i: number) => (
            <Card {...cardData.fields} key={i} />
          ))}
        </>
      </div>
    </div>
  )
}

export default GrantsIndex
